<template>
  <div>
    <app-header></app-header>
    <div class="bg">
      <div class="container content">
        <div class="no-players">
          <div class="text" style="text-align: center">
            Cамоконтроль рисков нарушения антимонопольного законодательства.
            <br>
            Добро пожаловать!
            <br>
          </div>
          <div class="col">
            <form @submit.prevent="login">
              <div class="form-group">
                <label>Email</label>
                <input type="text" id="email" v-model="email">
              </div>
              <div class="form-group">
                <label>Код доступа</label>
                <input type="text" id="password" v-model="password">
                <p style="margin-left: 110px;">Код доступа направлен на электронную почту, указанную при регистрации</p>
              </div>
              <div class="form-group" style="justify-content: start">
                <label></label>
                <button class="btn" type="submit">Войти</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import StartGroup from './StartGroup'
  import StartPlayer from './StartPlayer'
  import StartTest from './StartTest'
  import EnterName from './EnterName'
  import PlayersService from '@/services/PlayersService'

  export default {
    name: 'PlayerLogin',
    components: {
      StartGroup,
      StartPlayer,
      StartTest,
      EnterName
    },
    data () {
      return {
        email: '',
        password: ''
      }
    },
    computed: {
      groupId () {
        return this.$store.getters.groupId
      },
      playerId () {
        return this.$store.getters.getPlayer.id
      },
      testId () {
        return this.$store.getters.testId
      }
    },
    methods: {
      login () {
        let router = this.$router
        let store = this.$store
        this.$store.dispatch('signin',
          {
            email: this.email,
            password: this.password,
            callback () {
              PlayersService.getAll(this.email).then(
                (response) => {
                  let players = response
                  let player = players.results[0]
                  store.dispatch('setPlayer', player)
                  router.push({name: 'Start'})
                }
              )
            }
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  .bg {
    position: relative;
  }

  #logo {
    width: 400px;
    position: absolute;
    top: 20px;
    left: 0;
    max-width: 100%;
  }

  #kfu {
    height: 55vh;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .content {
    min-height: calc(100vh - 89px - 122px);
    position: relative;
  }

  .no-players {
    margin-top: 100px;
    @media screen and (max-width: 500px) {
      margin-top: 70px;
    }
    .text {
      color: #000 !important;
      font-weight: 350;
      font-size: 2.0em;
      line-height: 1.5em;
      @media screen and (max-width: 500px) {
        line-height: 1.3em;
      }
    }
  }

  .search-players {
    width: 100%;

    b {
      font-weight: 400;
      font-size: 1.5em;
      display: flex;
    }
  }

  .btn {
    margin-top: 20px;
    box-shadow: none;
    background-color: rgba(88, 162, 221, 0.7);
    border-radius: 10px;
    color: #fff;
    font-weight: 400;
    font-size: 24px;
    &:hover {
      background-color: rgba(88, 162, 221, 1);
      box-shadow: none;
    }
  }
  .label {
    font-weight: 300;
  }
  .form-checkbox {
    text-align: left;
    margin-left: 110px;
    font-weight: 300;
  }
  .col {
    width: 585px;
    max-width: 100%;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/game/PlayerLogin.vue